import React from "react";
import { PlayerTag } from "../badges";

function SideField({ label, value, mono }) {
    if (!value) return null;
    return (
        <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-1">
                {label}
            </div>
            <div className={`text-xs text-white/80 ${mono ? "font-mono" : ""}`}>{value}</div>
        </div>
    );
}

function SkillBars({ skills }) {
    if (!skills?.length) return null;
    return (
        <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-2">
                Skill weights
            </div>
            <div className="space-y-1">
                {skills.map(([k, v]) => (
                    <div key={k} className="flex items-center gap-2" data-testid={`skill-${k}`}>
                        <div className="font-mono text-[10px] uppercase tracking-wider text-white/70 flex-1 truncate">
                            {k.replace("skill_", "").replace(/([A-Z])/g, " $1")}
                        </div>
                        <div className="h-1 w-16 bg-white/5 relative">
                            <div
                                className="h-1 bg-fa-yellow"
                                style={{ width: `${Math.round(v * 100)}%` }}
                            />
                        </div>
                        <div className="font-mono text-[10px] text-fa-yellow w-8 text-right">
                            {Math.round(v * 100)}%
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

function PlayerPool({ players }) {
    if (!players?.length) return null;
    return (
        <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-2">
                Player pool
            </div>
            <div className="space-y-1.5">
                {players.map((p) => (
                    <div
                        key={p.id}
                        className="bg-black border border-white/10 px-2 py-1.5"
                        data-testid={`player-row-${p.id}`}
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-1.5">
                                <span className="font-mono text-[10px] uppercase text-white/50">
                                    {p.team}
                                </span>
                                <span className="font-display font-bold uppercase text-sm">
                                    {p.name}
                                </span>
                            </div>
                            <span className="font-mono text-[10px] text-fa-yellow">
                                £{p.price?.toFixed(1)}
                            </span>
                        </div>
                        {p.description && (
                            <div className="text-xs text-white/70 leading-snug mt-1">
                                {p.description}
                            </div>
                        )}
                        {!p.description && p.tags?.length > 0 && (
                            <div className="flex flex-wrap gap-1 mt-1">
                                {p.tags.map((t) => (
                                    <PlayerTag key={t} tag={t} />
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

/**
 * Right-column metadata panel (duration, contexts, skills, player pool).
 */
export default function ChallengeDetailSidePanel({ challenge, visibleSkills }) {
    return (
        <aside className="space-y-4">
            <SideField label="Duration" value={challenge.duration} />
            <SideField label="Table context" value={challenge.tableContext} />
            <SideField label="Match context" value={challenge.matchContext} />
            <SideField label="Rivalry" value={challenge.rivalryContext} />
            <SideField label="Generator reason" value={challenge.generatorReason} mono />
            <SideField label="Image prompt" value={challenge.imagePrompt} mono />
            <SkillBars skills={visibleSkills} />
            <PlayerPool players={challenge.players} />
        </aside>
    );
}
